import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        // the translations
        // (tip move them in a JSON file and import them,
        // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
        resources: {
            en: {
                translation: {
                    "location": "Tbilisi, Georgia",
                    "order": "Order now ❤️",
                    "flavours": "Our macarons flavours",
                    "allFlavoursAvailable": "All flavours are in stock and available to order",
                    "orderViaInstagram": "Order via Instagram",
                    "deliveryAvailable": "Delivery and pickup available",
                    "giftBoxes": "Gift boxes",
                    "macarons": "macarons",

                    "excellentQuality": "Excellent quality",
                    "premiumIngredients": "Premium Ingredients",
                    "almondFlour": "Almond flour (100% almonds)",
                    "sugarPowder": "Sugar/sugar powder",
                    "eggWhites": "Egg whites",
                    "glutenFree": "Gluten-free",

                    "finestBelgianChocolate": "Finest Belgian Chocolate",

                    "naturalFruitPuree": "Natural Fruit Puree",
                    "mango": "Mango",
                    "raspberry": "Raspberry",
                    "blackCurrant": "Black Currant",
                    "strawberry": "Strawberry",

                    "nutPaste100": "Nut Paste 100%",
                    "pistachio": "Pistachio",
                    "peanut": "Peanut",
                    "coconut": "Coconut",
                    "hazelnut": "Hazelnut",

                    "allergens": "Allergens",
                    "milk": "Milk",
                    "egg": "Egg",
                    "almond": "Almond",

                    "forYourConvenience": "For your convenience",

                    "storageAndService": "Storage and serving",
                    "take15minutesBefore": "Take out the box from the fridge 15 minutes before serving.",
                    "keepInFridge": "Keep in the bottom of your fridge within 5 days.",

                    "delivery": "Delivery",
                    "deliveryTerms1": "Delivery via the Bolt® Delivery or Yandex® Delivery applications is charged separately.",
                    "deliveryTerms2": "Pickup is possible.",

                    "composeYourBox": "Preparation",
                    "composeYourBoxTerms1": "The order is prepared in 1 hour from the available flavors.",
                    "composeYourBoxTerms2": "Corporate orders are prepared in 3-5 days.",

                    "workingHours": "Working hours",
                    "workingHoursTerms": "We work every day from 10 to 22.",

                    "chooseAnyFlavour": "Choose any flavours you like",

                    "createYourBox": "Create your box",
                    "availableBoxes": "Available boxes: 5, 10, 16, and 20 macarons",
                    "justKeepAdding": "Just keep adding or removing a flavour to make box bigger or smaller",

                    "yourOrder": "Your order",
                    "yourOrderDetailsWillAppear": "Your order details will appear here",
                    "total": "Total",
                    "clearOrder": "Clear order",
                    "confirmOrder": "Confirm order",
                    "completeBoxFirst": "Please, complete your box first ❤️",

                    "yourBox": "Your box",
                    "added": "added",
                    "removed": "removed",
                    "yourBoxIsReady": "Your box is ready to order!",
                    "keepAddingBox": "Add more to make your box bigger.",


                    "minimalOrder": "Minimal order is 5 macarons",
                    "orderNumber": "Order number",

                    "boxContentReceived": "We have already received your box content ❤️",
                    "contactUsForDelivery": "Please contact us via any convenient messenger to clarify the details of payment and delivery:",
                    "orLeaveYourContacts": "You can also leave your contacts and we'll get back to you:",

                    "close": "Close",

                    "yourName": "Your name",
                    "yourPhone": "Your phone or nickname",
                    "messenger": "Messenger",
                    "inputYourName": "Please enter your name",
                    "inputYourPhone": "Please enter your phone or nickname",
                    "chooseMessengerType": "Please choose a messenger type",
                    "longValue": "The value is too long",
                    "send": "Send",
                    "sent": "Sent",

                    "weWillContactYou": "We'll get back to you soon ❤️",

                    "inStockOnly": "Currently in stock: ",
                    "tryOtherFlavours": "Try other flavours ❤️",

                    "reserved": "reserved",
                    "areYourSureToCleanConfirmedOrder": "Are you sure you want to clear confirmed order?",
                    "yes": "Yes",
                    "no": "No",

                    "assorted": "Assorted",

                    "contacts": "Contacts",
                    "weWillBeHappyToHelpYou": "We will be happy to help you with any questions!",
                    "reachUsDaily": "Reach us daily from 09:00 to 22:00 GMT+4.",
                    "instagram": "Instagram",
                    "whatsapp": "WhatsApp",
                    "telegram": "Telegram",
                    "email": "E-mail",
                }
            },
            ka: {
                translation: {
                    "location": "თბილისი, საქართველო",
                    "order": "შეკვეთა ❤️",
                    "flavours": "ჩვენი მაკარონის არომატები",
                    "allFlavoursAvailable": "ყველა არომატი არის საწყობში და ხელმისაწვდომია შეკვეთისთვის",
                    "orderViaInstagram": "შეკვეთა Instagram-ის საშუალებით",
                    "deliveryAvailable": "მიწოდება და პიკაპის ხელმისაწვდომია",
                    "giftBoxes": "სასაჩუქრე ყუთები",
                    "macarons": "მაკარონი",

                    "excellentQuality": "შესანიშნავი ხარისხი",
                    "premiumIngredients": "პრემიუმ ინგრედიენტები",
                    "almondFlour": "ნუშის ფქვილი (100% ნუში)",
                    "sugarPowder": "შაქარი/შაქრის ფხვნილი",
                    "eggWhites": "კვერცხის ცილა",
                    "glutenFree": "წებოვანა თავისუფალი",

                    "finestBelgianChocolate": "საუკეთესო ბელგიური შოკოლადი",

                    "naturalFruitPuree": "ნატურალური ხილის პიურე",
                    "mango": "მანგო",
                    "raspberry": "ჟოლო",
                    "blackCurrant": "შავი მოცხარი",
                    "strawberry": "მარწყვი",

                    "nutPaste100": "თხილის პასტა 100%",
                    "pistachio": "ფისტა",
                    "peanut": "არაქისი",
                    "coconut": "ქოქოსი",
                    "hazelnut": "თხილი",

                    "allergens": "ალერგენები",
                    "milk": "რძე",
                    "egg": "კვერცხი",
                    "almond": "ნუში",

                    "forYourConvenience": "თქვენი მოხერხებულობისთვის",

                    "storageAndService": "შენახვა და მომსახურება",
                    "take15minutesBefore": "გამოიღეთ ყუთი მაცივრიდან მირთმევამდე 15 წუთით ადრე.",
                    "keepInFridge": "შეინახეთ მაცივრის ბოლოში 5 დღის განმავლობაში.",

                    "delivery": "მიწოდება",
                    "deliveryTerms1": "მიწოდების მეშვეობით Bolt® Delivery ან Yandex® Delivery განაცხადების ბრალი ცალკე.",
                    "deliveryTerms2": "პიკაპის შესაძლებელია.",

                    "composeYourBox": "შეკვეთის მომზადება",
                    "composeYourBoxTerms1": "შეკვეთა მზადდება 1 საათში არსებული არომატიდან.",
                    "composeYourBoxTerms2": "კორპორატიული შეკვეთები მზადდება 3-5 დღეში.",

                    "workingHours": "სამუშაო საათები",
                    "workingHoursTerms": "ჩვენ ვმუშაობთ ყოველდღე 10-დან 22-მდე.",

                    "chooseAnyFlavour": "აირჩიეთ ნებისმიერი არომატი, რომელიც მოგწონთ",

                    "createYourBox": "შექმენით თქვენი ყუთი",
                    "availableBoxes": "ხელმისაწვდომი ყუთები: 5, 10, 16 და 20 მაკარონი",
                    "justKeepAdding": "უბრალოდ გააგრძელეთ არომატის დამატება ან ამოღება, რათა ყუთი უფრო დიდი ან პატარა იყოს",

                    "yourOrder": "თქვენი შეკვეთა",
                    "yourOrderDetailsWillAppear": "თქვენი შეკვეთის დეტალები გამოჩნდება აქ",
                    "total": "სულ",
                    "clearOrder": "წმინდა წესრიგი",
                    "confirmOrder": "დაადასტურეთ შეკვეთა",
                    "completeBoxFirst": "გთხოვთ, შეავსოთ თქვენი ყუთი პირველი ❤️",

                    "yourBox": "შენი ყუთი",
                    "added": "დამატებულია",
                    "removed": "ამოღებულია",
                    "yourBoxIsReady": "თქვენი ყუთი მზად არის შეკვეთა!",
                    "keepAddingBox": "დაამატეთ მეტი, რომ თქვენი ყუთი უფრო დიდი გახდეს.",


                    "minimalOrder": "მინიმალური შეკვეთა 5 მაკარონია",
                    "orderNumber": "შეკვეთის ნომერი",

                    "boxContentReceived": "ჩვენ უკვე მივიღეთ თქვენი ყუთის შინაარსი ❤️",
                    "contactUsForDelivery": "გთხოვთ დაგვიკავშირდეთ ნებისმიერი მოსახერხებელი მესენჯერის საშუალებით, რათა განვმარტოთ გადახდისა და მიწოდების დეტალები:",
                    "orLeaveYourContacts": "ან დატოვეთ თქვენი კონტაქტები და ჩვენ დაგიბრუნდებით:",

                    "close": "დახურვა",

                    "yourName": "შენი სახელი",
                    "yourPhone": "თქვენი ნომერი ან ანგარიში",
                    "messenger": "მესენჯერი",
                    "inputYourName": "გთხოვთ შეიყვანოთ თქვენი სახელი",
                    "inputYourPhone": "გთხოვთ შეიყვანოთ თქვენი ტელეფონის ნომერი ან ანგარიში",
                    "chooseMessengerType": "გთხოვთ აირჩიოთ მესენჯერი",
                    "longValue": "ღირებულება ძალიან გრძელია",
                    "send": "გაგზავნა",
                    "sent": "გაიგზავნება",

                    "weWillContactYou": "მალე დაგიბრუნდებით ❤️",

                    "inStockOnly": "საწყობში: ",
                    "tryOtherFlavours": "სცადეთ სხვა არომატები ❤️",

                    "reserved": "დაცულია",
                    "areYourSureToCleanConfirmedOrder": "დარწმუნებული ხართ, რომ გსურთ დადასტურებული შეკვეთის გაწმენდა?",
                    "yes": "დიახ",
                    "no": "არა",

                    "assorted": "ასორტი",

                    "contacts": "კონტაქტი",
                    "weWillBeHappyToHelpYou": "მოხარული ვიქნებით დაგეხმაროთ ნებისმიერ კითხვაში!",
                    "reachUsDaily": "შეგიძლიათ დაგვიკავშირდეთ 09:00 საათიდან 22:00 საათამდე GMT+4.",
                    "instagram": "Instagram",
                    "whatsapp": "WhatsApp",
                    "telegram": "Telegram",
                    "email": "E-mail",
                }
            },
            ru: {
                translation: {
                    "location": "Тбилиси, Грузия",
                    "order": "Заказать ❤️",
                    "flavours": "Вкусы наших макарон",
                    "allFlavoursAvailable": "В наличии и доступны для заказа",
                    "orderViaInstagram": "Заказать в Instagram",
                    "deliveryAvailable": "Доступна доставка и самовывоз",
                    "giftBoxes": "Подарочные коробки",
                    "macarons": "макарон",

                    "excellentQuality": "Исключительное качество",
                    "premiumIngredients": "Премиальные ингредиенты",
                    "almondFlour": "Миндальная мука (100% миндаль)",
                    "sugarPowder": "Сахар/сахарная пудра",
                    "eggWhites": "Яичные белки",
                    "glutenFree": "Не содержит глютен",

                    "finestBelgianChocolate": "Бельгийский шоколад",

                    "naturalFruitPuree": "Натуральное фруктовое пюре",
                    "mango": "Манго",
                    "raspberry": "Малина",
                    "blackCurrant": "Чёрная смородина",
                    "strawberry": "Клубника",

                    "nutPaste100": "100% ореховая паста",
                    "pistachio": "Фисташка",
                    "peanut": "Арахис",
                    "coconut": "Кокос",
                    "hazelnut": "Фундук",

                    "allergens": "Аллергены",
                    "milk": "Молоко",
                    "egg": "Яйца",
                    "almond": "Миндаль",

                    "forYourConvenience": "Для Вашего удобства",

                    "storageAndService": "Хранение и подача",
                    "take15minutesBefore": "Достаньте коробку из холодильника за 15 минут до подачи.",
                    "keepInFridge": "Храните в нижней части холодильника, не более 5 дней.",

                    "delivery": "Доставка",
                    "deliveryTerms1": "Доставка через Bolt® Delivery или Yandex® Delivery, оплачивается отдельно.",
                    "deliveryTerms2": "Доступен самовывоз.",

                    "composeYourBox": "Сборка заказа",
                    "composeYourBoxTerms1": "Заказ собирается в течение 1 часа из вкусов в наличии.",
                    "composeYourBoxTerms2": "Корпоративные заказы готовятся в течение 3-5 дней.",

                    "workingHours": "Режим работы",
                    "workingHoursTerms": "Мы работаем ежедневно с 10 до 22 часов.",

                    "chooseAnyFlavour": "Вы можете выбрать любую комбинацию вкусов из наличия",

                    "createYourBox": "Создайте свою коробочку",
                    "availableBoxes": "Доступные размеры: 5, 10, 16 или 20 макарон",
                    "justKeepAdding": "Добавляйте или убирайте вкусы, чтобы сделать коробку больше или меньше",

                    "yourOrder": "Ваш заказ",
                    "yourOrderDetailsWillAppear": "Здесь будут детали вашего заказа",
                    "total": "Итого",
                    "clearOrder": "Очистить заказ",
                    "confirmOrder": "Подтвердить заказ",
                    "completeBoxFirst": "Заполните коробку любимыми вкусами ❤️",

                    "yourBox": "Ваша коробка",
                    "added": "добавлено",
                    "removed": "убрано",
                    "yourBoxIsReady": "Ваша коробка готова для заказа!",
                    "keepAddingBox": "Добавьте еще, чтобы сделать коробку больше.",


                    "minimalOrder": "Минимальный заказ — 5 макарон",
                    "orderNumber": "Номер заказа",

                    "boxContentReceived": "Мы уже получили детали вашего заказа ❤️",
                    "contactUsForDelivery": "Пожалуйста, напишите нам в любом удобном мессенджере для уточнения деталей по оплате и доставке:",
                    "orLeaveYourContacts": "Либо оставьте контакты и мы свяжемся с Вами:",

                    "close": "Закрыть",

                    "yourName": "Ваше имя",
                    "yourPhone": "Ваш номер или аккаунт",
                    "messenger": "Мессенджер",
                    "inputYourName": "Пожалуйста, введите Ваше имя",
                    "inputYourPhone": "Пожалуйста, введите Ваш номер или аккаунт",
                    "chooseMessengerType": "Пожалуйста, выберите мессенджер",
                    "longValue": "Значение слишком длинное",
                    "send": "Отправить",
                    "sent": "Отправлено",

                    "weWillContactYou": "Мы скоро с Вами свяжемся ❤️",

                    "inStockOnly": "В наличии: ",
                    "tryOtherFlavours": "Попробуйте другие вкусы ❤️",

                    "reserved": "зарезервировано",
                    "areYourSureToCleanConfirmedOrder": "Вы уверены, что хотите очистить подтвержденный заказ?",
                    "yes": "Да",
                    "no": "Нет",

                    "assorted": "Ассорти",

                    "contacts": "Контакты",
                    "weWillBeHappyToHelpYou": "Мы будем рады помочь Вам с любым вопросом!",
                    "reachUsDaily": "Вы можете связаться с нами с 09:00 до 22:00 GMT+4.",
                    "instagram": "Instagram",
                    "whatsapp": "WhatsApp",
                    "telegram": "Telegram",
                    "email": "E-mail",
                }
            },
        },
        lng: localStorage.getItem('language') || 'en',
        fallbackLng: "en",
        interpolation: {
            escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
        }
    });

export default i18n;